import { getEnvironmentConfig, getEnvVariableDefault } from '../configHelper.js';
const definition = {
    base: {
        sqsUrl: 'missing configuration for imageInvalidGalleryExpire SQS URL for this environment',
        isConsumerEnabled: true,
    },
    local: {
        sqsUrl: 'http://localhost:4566/000000000000/imageInvalidGalleryExpireEventsQueue',
    },
    local_k8s: {
        sqsUrl: 'http://localstack:4566/000000000000/imageInvalidGalleryExpireEventsQueue',
    },
    local_e2e: {
        sqsUrl: 'http://localstack:4566/000000000000/imageInvalidGalleryExpireEventsQueue',
    },
    test: {
        isConsumerEnabled: false,
    },
    sandbox: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('IMAGE_INVALID_GALLERY_EXPIRE_EVENTS_QUEUE_NAME', 'image_invalid_gallery_expire_events_queue')}`,
    },
    development: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('IMAGE_INVALID_GALLERY_EXPIRE_EVENTS_QUEUE_NAME', 'image_invalid_gallery_expire_events_queue')}`,
    },
    staging: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('IMAGE_INVALID_GALLERY_EXPIRE_EVENTS_QUEUE_NAME', 'image_invalid_gallery_expire_events_queue')}`,
    },
    production: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('IMAGE_INVALID_GALLERY_EXPIRE_EVENTS_QUEUE_NAME', 'image_invalid_gallery_expire_events_queue')}`,
    },
};
export const imageInvalidGalleryExpireConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=imageInvalidGalleryExpire.config.js.map